import * as yup from 'yup';

export const schema = yup.object().shape({
  password: yup
    .string()
    .min(6, 'Deve conter no mínimo 6 dígitos.')
    .required('Digite sua senha para continuar.'),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref('password'), null], 'As duas senhas não conferem.')
    .min(6, 'Deve conter no mínimo 6 dígitos.')
    .required('Confirme a senha para continuar.'),
});
